<template>
    <section container>
        <section banner v-if="articleData" :style="{height: '300' + 'px'}">
            <div content class="d-block">
                <h1 class="b-title">{{ articleData.title }}</h1>
                <h1 class="b-desc">{{ articleData.desc }}</h1>
            </div>
        </section>

        <section content padding article v-if="articleData">
            <div data-box="article" class="d-block" v-html="articleData.content"/>
        </section>

        <section content padding loading v-if="!articleData">
            <Spin fix/>
        </section>
    </section>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                articleData: null,
            }
        },
        async created() {
            await this.getSummaryDetail();
        },
        methods: {
            async getSummaryDetail(){
                let res = await this.$api.getHttp('product/summary-detail?id=' + this.$route.query.id + '&lang=' + this.$common.config.lang);
                this.articleData = {} = res.data.data;
                console.log('this.getSummaryDetail---------->', res.data.data);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/product/summary.vue